// extracted by mini-css-extract-plugin
export var paddingLeftLg = "VerticalSpacing-module--padding-left-lg--0131d";
export var paddingLeftMd = "VerticalSpacing-module--padding-left-md--aec50";
export var paddingLeftSm = "VerticalSpacing-module--padding-left-sm--7d54b";
export var paddingLeftXl = "VerticalSpacing-module--padding-left-xl--3a80f";
export var paddingLeftXs = "VerticalSpacing-module--padding-left-xs--546c9";
export var paddingLeftXxl = "VerticalSpacing-module--padding-left-xxl--78d48";
export var paddingRightLg = "VerticalSpacing-module--padding-right-lg--31678";
export var paddingRightMd = "VerticalSpacing-module--padding-right-md--17416";
export var paddingRightSm = "VerticalSpacing-module--padding-right-sm--3e4ce";
export var paddingRightXl = "VerticalSpacing-module--padding-right-xl--d24ea";
export var paddingRightXs = "VerticalSpacing-module--padding-right-xs--0ce7b";
export var paddingRightXxl = "VerticalSpacing-module--padding-right-xxl--5b389";